export const INTERVIEW_FORMAT_CRITERIA_MODEL = "interview-format-criteria";

const interviewFormatCriteriaModel = {
  criteriaName: "",
  maximumValue: 0,
  minimumValue: 0
};

export default interviewFormatCriteriaModel;
